var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRacingGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Car-Dashboard-Steering--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Car Dashboard Steering Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 3.5a8.48 8.48 0 0 1 7.82 5.2 0.25 0.25 0 0 1 0 0.26 0.23 0.23 0 0 1 -0.25 0.07A28.51 28.51 0 0 0 4.47 9a0.23 0.23 0 0 1 -0.25 0 0.25 0.25 0 0 1 0 -0.26A8.48 8.48 0 0 1 12 3.5Zm1.5 8.5a1.5 1.5 0 1 1 -1.5 -1.5 1.5 1.5 0 0 1 1.5 1.5ZM4 13a6 6 0 0 1 5.92 7 0.25 0.25 0 0 1 -0.11 0.17 0.24 0.24 0 0 1 -0.2 0 8.51 8.51 0 0 1 -6 -6.86 0.25 0.25 0 0 1 0.06 -0.2 0.28 0.28 0 0 1 0.17 -0.11Zm10.29 7.18a0.19 0.19 0 0 1 -0.13 0 0.14 0.14 0 0 1 -0.07 -0.1A5.74 5.74 0 0 1 14 19a6 6 0 0 1 6 -6h0.17a0.27 0.27 0 0 1 0.18 0.1 0.21 0.21 0 0 1 0 0.19 8.5 8.5 0 0 1 -6.06 6.89Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRacingGames);
export default ForwardRef;